<section class="confirmation">

  <h2 mat-dailog-title class="text-center">
    Invite new Person for this company
  </h2>
  @if (invitePersonForm) {
    <form [formGroup]="invitePersonForm">
      <mat-form-field class="py-3">
        <mat-label>Email of inviting person</mat-label>
        <input
          matInput
          type="text"
          formControlName="personEmail">
          @if (hasErrorOfType('personEmail', 'required') || hasErrorOfType('personEmail', 'email')
            || hasErrorOfType('personEmail', 'maxlength')) {
            <mat-error
              >
              Enter a valid email address.
            </mat-error>
          }
          @if (hasErrorOfType('personEmail', 'emailInUse')) {
            <mat-error
              >
              User with entered email already exists on platform. Enter different one.
            </mat-error>
          }
        </mat-form-field>
      </form>
    }
    <div class="btn-group my-3" role="group">
      <button
        mat-button
        [mat-dialog-close]="invitePersonForm.invalid ? '' : personEmailCtrl.value"
      [disabled]="invitePersonForm.invalid || inProgress">Invite</button>
      <button mat-button mat-dialog-close>Cancel</button>
    </div>

  </section>